import React from "react";
import { Maximize2, SwitchCamera } from "lucide-react";
import CameraActionButton from "./CameraActionButton";
import RotateDeviceOverlay from "./RotateDeviceOverlay";

// phase === "active": monitoring is live, fill the screen with the feed.
const ActiveScreen = ({
  candidateName,
  jobRole,
  isFullscreen,
  fullscreenSupported,
  connectionLost,
  videoRefCallback,
  onRotate,
  onToggleFullscreen,
  isLandscape,
}) => (
  <div
    className={`bg-gray-900 text-white h-screen ${isFullscreen ? "p-0" : "p-2"}`}
    style={{
      height: "100dvh",
      paddingTop: isFullscreen ? undefined : "calc(0.5rem + env(safe-area-inset-top))",
    }}
  >
    {!isFullscreen && (
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-3 mb-2 border border-gray-700/50 flex items-center justify-between">
        <div className="min-w-0">
          <p className="text-xs text-gray-300 truncate">
            {candidateName} {jobRole ? `· ${jobRole}` : ""}
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <div
            className={`w-2 h-2 rounded-full animate-pulse ${
              connectionLost ? "bg-amber-500" : "bg-green-500"
            }`}
          />
          <span className="text-xs text-gray-400">
            {connectionLost ? "Reconnecting…" : "Monitoring"}
          </span>
        </div>
      </div>
    )}

    <div
      className={`relative bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 ${
        isFullscreen ? "h-screen rounded-none" : "h-[calc(100vh-88px)] rounded-lg"
      }`}
      style={{ height: isFullscreen ? "100dvh" : "calc(100dvh - 88px)" }}
    >
      <video
        ref={videoRefCallback}
        autoPlay
        playsInline
        muted
        className={`w-full h-full object-cover ${isFullscreen ? "rounded-none" : "rounded-lg"}`}
      />

      {!isLandscape && <RotateDeviceOverlay />}

      {/* Overlay so it's visible in fullscreen too, where the header badge is hidden. */}
      {connectionLost && (
        <div
          className="absolute left-4 right-4 bg-amber-900/70 backdrop-blur-sm border border-amber-500/50 rounded-lg px-3 py-2 text-center"
          style={{ top: "calc(0.75rem + env(safe-area-inset-top))" }}
        >
          <p className="text-xs text-amber-100">Connection lost. Reconnecting…</p>
        </div>
      )}

      <div
        className="absolute left-4 right-4"
        style={{ bottom: "calc(1rem + env(safe-area-inset-bottom))" }}
      >
        <div className="flex gap-2">
          <CameraActionButton onClick={onRotate} title="Switch Camera" icon={SwitchCamera} />
          {fullscreenSupported && (
            <CameraActionButton onClick={onToggleFullscreen} title="Toggle Fullscreen" icon={Maximize2} />
          )}
        </div>
      </div>
    </div>
  </div>
);

export default ActiveScreen;
